import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { CategoryModule } from './category.module';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
    httpOptions = { 
        headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' })
    };

    private headers: HttpHeaders;
    constructor(private http: HttpClient) {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    }

    getCategory(type: string): Observable<CategoryModule[]> {
        return this.http.get<CategoryModule[]>(environment.apiURL + 'General/GNCategory/search/' + type);
    }

    getServiceId(id: number): Observable<CategoryModule[]> {
        return this.http.get<CategoryModule[]>(environment.apiURL + 'General/GNCategory/' + id);
    }


    formData: CategoryModule = new CategoryModule();
    list: CategoryModule[];

   
}
